// @flow

import styled, { css } from 'styled-components';
import { Box } from '../../../grid';
import media from '../../../../helpers/media';
import type { Theme } from '../../../../types';

const StepsComponent = styled<any, Theme>('div')`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;

  &::after {
    content: '';
  }

  ${media.lg(css`
    display: block;
  `)}
`;

const StepsContainer = styled<typeof Box, Theme, _>(Box)`
  display: none;

  ${media.md(css`
    display: flex;
    width: 100%;
  `)}
`;

export {
  StepsComponent,
  StepsContainer,
};

export default null;
